var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUkiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    fill: "current",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_463",
    "data-name": "\\uADF8\\uB8F9 463",
    transform: "translate(-1038 -819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_23",
    "data-name": "\\uD0C0\\uC6D0 23",
    d: "M28,2A26.007,26.007,0,0,0,17.88,51.958,26.007,26.007,0,0,0,38.12,4.042,25.835,25.835,0,0,0,28,2m0-2A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(1038 819)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "P",
    transform: "translate(1067 858)",
    fontSize: 30,
    fontFamily: "Pretendard-ExtraBold, Pretendard",
    fontWeight: 800,
    letterSpacing: "0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.422,
    y: 0
  }, "P")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkiki);
export default __webpack_public_path__ + "static/media/ukiki.7ee533c43890d6baa04edd87b8333c29.svg";
export { ForwardRef as ReactComponent };